import type { PhaseType } from "../hooks/useCycles";

/**
 * Phases that represent an ongoing interval and can meaningfully use a day
 * counter in patient-facing timeline copy.
 *
 * Trigger shots are events stored on the protocol phase, so they are not
 * included here. Procedure phases deliberately stay date/state-based.
 */
export const DURATION_PHASE_TYPES: ReadonlySet<PhaseType> = new Set([
  "pre_treatment",
  "protocol",
  "embryo_development",
  "luteal_phase",
]);

export function isDurationPhaseType(
  phaseType: PhaseType | null | undefined,
): boolean {
  return phaseType != null && DURATION_PHASE_TYPES.has(phaseType);
}
